// components/AdminWrapper.js
import React, { useState } from 'react';
import AdminPage from './AdminPage';
import AdminPageSZ from './AdminPageSZ';

const ADMIN_VARIANT = process.env.REACT_APP_ADMIN_VARIANT || 'SINGLE_ZERO'; // 'SINGLE_ZERO' or 'DOUBLE_ZERO'

const AdminWrapper = () => {
  const [variant, setVariant] = useState(ADMIN_VARIANT);

  // const handleToggle = () => {
  //   setVariant((prev) => (prev === 'SINGLE_ZERO' ? 'DOUBLE_ZERO' : 'SINGLE_ZERO'));
  // };

  const isSingleZero = variant === 'SINGLE_ZERO';

  return (
    <>
      {/* <button className="variant-toggle-btn variant-toggle-btn--admin" onClick={handleToggle}>
        {isSingleZero ? 'Switch: DOUBLE ZERO' : 'Switch: SINGLE ZERO'}
      </button> */}
      {/* SINGLE_ZERO -> AdminPageSZ, DOUBLE_ZERO -> AdminPage (mirror WheelWrapper) */}
      {/* {isSingleZero ? <AdminPageSZ /> : <AdminPage />} */}
      {isSingleZero ? <AdminPageSZ /> : <AdminPage />}
    </>
  );
};

export default AdminWrapper;


// // components/AdminWrapper.js
// import React, { useState, useEffect } from 'react';
// import { useAuth } from '../context/AuthContext';
// import axios from 'axios';
// import { API_URL } from '../environment';
// import AdminPage from './AdminPage';
// import AdminPageSZ from './AdminPageSZ';

// const AdminWrapper = () => {
//   const { user } = useAuth();
//   const [type, setType] = useState(null);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   useEffect(() => {
//     const forcedType = process.env.REACT_APP_ADMIN_TYPE; // <-- build-time override

//     // If image is built with REACT_APP_ADMIN_TYPE, skip API detection entirely
//     if (forcedType) {
//       setType(forcedType);
//       setLoading(false);
//       return;
//     }

//     const fetchType = async () => {
//       try {
//         const response = await axios.get(`${API_URL}/get-user-type`, {
//           headers: { Authorization: `Bearer ${localStorage.getItem('sun_token')}` },
//         });
//         setType(response.data.type);
//       } catch (err) {
//         setError('Failed to load admin config');
//         console.error(err);
//       } finally {
//         setLoading(false);
//       }
//     };

//     fetchType();
//   }, [user]);

//   if (loading) return <div>Loading admin page...</div>;
//   if (error) return <div>{error}</div>;

//   if (type === 'SINGLE_ZERO') return <AdminPageSZ />;
//   // Treat DOUBLE_ZERO (and everything else) as standard AdminPage
//   return <AdminPage />;
// };

// export default AdminWrapper;

